<id-footer headline="Klientverktyg" class="ids-hide ids-show-inera-admin" type="inera-admin">
  <p>
    Inera skapar förutsättningar för att digitalisera välfärden genom att tillhandahålla en gemensam digital
    infrastruktur och arkitektur.
  </p>

  <p slot="sub-footer-left">
    Klientverktyg drivs av
    <id-link class="ids-mr-1" [light]="true">
      <a href="https://www.inera.se" style="font-size: 0.875rem">
        Inera AB
        <id-icon-external width="0.875rem" height="0.875rem" [inline]="true"></id-icon-external>
      </a>
    </id-link>
    på uppdrag av Sveriges regioner.
  </p>

  <p slot="sub-footer-mobile">
    Klientverktyg drivs av
    <id-link class="ids-mr-1" [light]="true">
      <a href="https://www.inera.se" style="font-size: 0.875rem">
        Inera AB
        <id-icon-external width="0.875rem" height="0.875rem" [inline]="true"></id-icon-external>
      </a>
    </id-link>
    på uppdrag av Sveriges regioner.
  </p>
</id-footer>
